(() => {
    function init() {
        document.querySelectorAll('.product-compare__container .product-compare__create-button').forEach((button) => {
            button.addEventListener('click', () => {
                const value = button.dataset.optionValue;
                
                if (document.body.classList.contains('template-product')) {
                    const select = document.querySelector('#' + [...(document.querySelectorAll('.product-details__option-wrapper label'))].filter(item =>
                        item.innerText.trim().toLowerCase() === button.closest('.product-compare__container').dataset.optionName.toLowerCase()
                    )[0].attributes['for'].value);

                    select.value = value;

                    select.dispatchEvent(
                        new Event('change', {
                            bubbles: true
                        })
                    );

                    const element = select.closest('.product-details__options');

                    if (!element) return;

                    window.scrollTo({
                        top: element.getBoundingClientRect().top + window.pageYOffset - 80,
                        behavior: 'smooth'
                    });
                } else {
                    [...(document.querySelectorAll('.product-item .product-item__title'))].filter(item =>
                        item.innerText.trim().toLowerCase() === button.dataset.optionValue.toLowerCase()
                    )[0].closest('.product-item').querySelector('.opt-product-cta').click();
                }
            });

            if (document.body.classList.contains('template-collection')) {
                [...button.closest('.product-compare__columns').querySelectorAll('.product-compare__feature-value')].filter(el => el.innerText.trim() === '\{\{price\}\}').forEach(el => {
                    const columns = window.getComputedStyle(el.closest('.product-compare__columns')).getPropertyValue('--columns').trim();
                    if(button.closest('.product-compare__feature').style.order % columns !== el.closest('.product-compare__feature').style.order % columns) return;
                    
                    const productTile = [...(document.querySelectorAll('.product-item .product-item__title'))].filter(item =>
                                            item.innerText.trim().toLowerCase() === button.dataset.optionValue.toLowerCase()
                                        )[0].closest('.product-item');

                    const priceEl = productTile.querySelector('.product-item__price').cloneNode(true);
                    priceEl.querySelector('.product-item__price-was').remove();
                    el.innerText = priceEl.innerText.trim().replaceAll(/[ \n]+/g, ' ');
                });
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();